module.exports = __webpack_public_path__ + "static/media/logo1.2278f168.svg";